(() => {
  const DESKTOP_QUERY = window.matchMedia('(min-width: 990px)');
  const REDUCED_MOTION_QUERY = window.matchMedia('(prefers-reduced-motion: reduce)');

  let ticking = false;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function updateSection(section) {
    const track = section.querySelector('.jax-moments__gallery');

    if (!track) return;

    const isDesktop = DESKTOP_QUERY.matches;
    const reducedMotion = REDUCED_MOTION_QUERY.matches;

    if (!isDesktop || reducedMotion) {
      track.style.transform = '';
      return;
    }

    const rect = section.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    /*
      Progress starts at 0 as the section approaches the viewport
      and reaches 1 as it moves through it.
    */
    const travelDistance = rect.height + viewportHeight;
    const travelled = viewportHeight - rect.top;
    const progress = clamp(travelled / travelDistance, 0, 1);

    const start = Number(section.dataset.parallaxStart ?? 260);
    const end = Number(section.dataset.parallaxEnd ?? -360);

    const requestedMovement = start + ((end - start) * progress);

    /*
      Prevent the track from travelling beyond its available content.
      This keeps the final card inside the clipped viewport.
    */
    const wrap = section.querySelector('.jax-moments__gallery-wrap');
    const availableTravel = Math.max(
      0,
      track.scrollWidth - (wrap?.clientWidth ?? window.innerWidth)
    );

    const safeStart = clamp(start, -availableTravel, availableTravel);
    const safeEnd = clamp(end, -availableTravel, availableTravel);
    const safeMovement = clamp(
      requestedMovement,
      Math.min(safeStart, safeEnd),
      Math.max(safeStart, safeEnd)
    );

    track.style.transform = `translate3d(${safeMovement}px, 0, 0)`;
  }

  function updateAll() {
    document
      .querySelectorAll('[data-jax-moments-parallax]')
      .forEach(updateSection);

    ticking = false;
  }

  function requestUpdate() {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(updateAll);
  }

  function init() {
    requestUpdate();

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    DESKTOP_QUERY.addEventListener?.('change', requestUpdate);
    REDUCED_MOTION_QUERY.addEventListener?.('change', requestUpdate);

    document.addEventListener('shopify:section:load', requestUpdate);
    document.addEventListener('shopify:section:reorder', requestUpdate);
    document.addEventListener('shopify:block:select', requestUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();